<template>
    <BreadCrumb PageTitle="Mouvement du stock" />
    <MouvementDuStock />
</template>

<script lang="ts">
    import { defineComponent } from "vue";

    import BreadCrumb from "../../components/Common/BreadCrumb.vue";
    import MouvementDuStock from "../../components/Etats/MouvementDuStock.vue";

    export default defineComponent({
        name: "MouvementDuStockPage",
        components: {
            BreadCrumb,
            MouvementDuStock,
        },
    });
</script>